import React from "react";
import DepotInformations from "./DepotInformations";
import DepotStorekeepers from "./DepotStorekeepers";
import DepotAddresse from "./DepotAddresse";

const DepotForms = ({ forms, activeTab, setForms }) => {
  if (activeTab === "Informations") {
    return <DepotInformations forms={forms} setForms={setForms} />;
  } else if (activeTab === "Storekeepers") {
    return <DepotStorekeepers forms={forms || []} setForms={setForms} />;
  } else if (activeTab === "Address") {
    return <DepotAddresse forms={forms} setForms={setForms} />;
  }
  return null;
};

export default DepotForms;
